
class HXFormFieldPopup extends HXFormField {

    constructor(inputName, formName = null) {
        super(inputName, formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult = true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            var value = '' + this.getValue();
            var inputFocus = $('.js-' + this.inputName + '-field:not(:disabled):first'); //Erstes bearbeitbares Feld

            if (!this.getOptional() && (value === '' || value === '0')) {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }

            //Wenn eines der Eingabefelder befuellt ist, muss auch ein gueltiger Datensatz gefunden worden sein
            $('.js-' + this.inputName + '-field').each((index, element) => {
                if (element.value !=='' && (value==='' || value==='0')) {
                    this.validationMsg = hx.replace(this.formVars.dictFormatMsg, "#name#", this.getLabel());
                    this.validationPassed = false;
                    inputFocus = element;
                }
            });

            if (alertResult === true) super._validateFieldAlert(true,inputFocus);
        }
        return this.validationPassed;
    }


    /**
     * @param {HTMLInputElement} inputElement Hidden- oder Eingabefeld
     */
    loadData(inputElement) {
        var $field = $(inputElement);
        var col = $field.attr('data-col');
        var data = {};
        data[col] = $field.val();
        data['feldname'] = this.inputName;

        $.ajax({
            url: this.getLoadDataAjaxFilePath(),
            type: 'POST',
            data: data,
            async: false,
            dataType: 'json',
            success: ($json) => {

                //Alle Felder leeren
                this.inputObj.value = "";
                $('.js-' + this.inputName + '-field').each((index, name) => {
                    if ($(name).attr('name') !== this.inputName + '_' + col) $(name).val(''); //Eingabe Felder leeren
                });

                //Daten Eintragen
                if ($json != null) {
                    for (var item in $json) {
                        if ($field.attr('name') !== this.inputName + '_' + item) {
                            $('[name='+this.inputName+'_' + item + ']').val($json[item]);
                        } else if ($json[item] != null && $json[item] !== "") {
                            $('[name='+this.inputName+'_' + item + ']').val($json[item]);
                        }
                    }
                    if ($json[this.getDisplayTableIdColName()]!==undefined) this.inputObj.value = $json[this.getDisplayTableIdColName()];
                }
                //CallbackFunction aufrufen
                if (this.getLoadDataCallBackJsFuncName() !== "") window[this.getLoadDataCallBackJsFuncName()]();
            }
        });
    }

    /**
     * @return {boolean}
     */
    getSearchPopupDisplay() {
        return this.inputObj.getAttribute('data-hx-searchpopup-display') === 'true';
    }

    /**
     * @return {boolean}
     */
    getDetailPopupDisplay() {
        return this.inputObj.getAttribute('data-hx-detailpopup-display') === 'true';
    }

    /**
     * @return {string}
     */
    getSearchPopupJsFuncName() {
        return this.inputObj.getAttribute('data-hx-searchpopup-jsfunc');
    }

    /**
     * @return {string}
     */
    getDetailPopupJsFuncName() {
        return this.inputObj.getAttribute('data-hx-detailpopup-jsfunc');
    }

    /**
     * @return {string}
     */
    getLoadDataAjaxFilePath() {
        return this.inputObj.getAttribute('data-hx-loaddata-ajaxfilepath');
    }

    /**
     * @return {string}
     */
    getDisplayTableIdColName() {
        return this.inputObj.getAttribute('data-hx-displaytable-idcolname');
    }

    /**
     * @return {string}
     */
    getLoadDataCallBackJsFuncName() {
        return this.inputObj.getAttribute('data-hx-loaddata-callbackjsfunc');
    }

    /**
     * Setzt die id im hiddenfeld. Laedt dann die neuen Daten
     * @param {string|int} id
     */
    setValue(id) {
        super.setValue(id); //in Hiddenfeld schreiben
        this.loadData(this.inputObj); //Daten laden


    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'formfieldpopup');
    }

    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true && this.getEditable()===true) {

            //Manuelle Aenderung in Eingabefeldern - Datensatz suchen und laden
            if(this.getLoadDataAjaxFilePath()!=='') {
                $(".js-"+this.inputName+"-field").on('change', (event) => {
                    this.loadData(event.currentTarget);
                    this.inputObj.dispatchEvent(new Event('change'));
                });
            }

            //Klick auf Suchen-Button - nur im Editiermodus sichtbar
            $('.js-'+this.inputName+'-open_suche').on('click', (event)  => {
                event.preventDefault();
                if(this.getSearchPopupJsFuncName()!=="") window[this.getSearchPopupJsFuncName()](this.formVars.root,$('.js-'+this.inputName).val(),this.inputName);
            });

            $('.js-'+this.inputName+'-clear').on('click', (event)  => {
                event.preventDefault();
                this.setValue(0);
                this.inputObj.dispatchEvent(new Event('change'));
            });

            // Focus und Blur abfagen und an inputObj weiterleiten:
            let $container = $(this.inputObj).parent().parent();  // oberster Container
            let $inputObj = $(this.inputObj);  // InputObject

            // Event-Handler f�r focusin
            $container.on("focusin",  (event) => {
                if ($inputObj.attr("data-has_focus") != "1") {
                    $inputObj.attr("data-has_focus", "1");
                    this.inputObj.dispatchEvent(new Event('focus'));
                }
            });

            // Event-Handler f�r focusout
            $container.on("focusout", (event)=> {
                // �berpr�fen, ob der Fokus aus dem gesamten Container verloren geht (nicht innerhalb der Kinder-Elemente bleibt)
                if (!$.contains($container[0], event.relatedTarget)) {
                    if ($inputObj.attr("data-has_focus") == "1") {
                        $inputObj.attr("data-has_focus", "0");
                        this.inputObj.dispatchEvent(new Event('blur'));
                    }
                }
            });



        }

        //Klick auf Detail-Button - auch in ReadOnlymodus sichtbar
        $('.js-'+this.inputName+'-open_detail').on('click', (event) =>{
            event.preventDefault();
            if(this.inputObj.value !== '' && this.getDetailPopupJsFuncName()!=="") {
                window[this.getDetailPopupJsFuncName()](this.formVars.root,$('.js-'+this.inputName).val());
            }
        });


    }
}